import { Component, OnInit } from "@angular/core";
import { CompanyService, CustomerService } from "../../../services";
import { WebCompany, WebCustomer } from "../../../models";
import { DomSanitizer, SafeHtml, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-prebuy-contract",
  templateUrl: "./prebuy-contract.component.html",
  styleUrls: ["./prebuy-contract.component.scss"]
})
export class PrebuyContractComponent implements OnInit
{

  url: string = "";
  safeUrl: SafeResourceUrl;
  webCustomer: WebCustomer;

  constructor(
    private companyService: CompanyService,
    private customerService: CustomerService,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit(): void
  {

    this.customerService.customer.subscribe(c => this.webCustomer = c);

    // this.url = "assets/data/" + this.webCustomer.BranchCustId + ".pdf";

    // temporary path to file, need to use Corp ID for other stuff.
    this.url = "assets/data/A000ABCCOM.pdf";

    // is there a better way to do this?
    this.safeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.url);

  }
}
